import { render, staticRenderFns } from "./FriendZonePage.vue?vue&type=template&id=0dae4010&scoped=true&"
import script from "./FriendZonePage.vue?vue&type=script&lang=js&"
export * from "./FriendZonePage.vue?vue&type=script&lang=js&"
import style0 from "./FriendZonePage.vue?vue&type=style&index=0&id=0dae4010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae4010",
  null
  
)

export default component.exports